/**
 *  Модель для работы с сайдбаром
 */

import { createModel } from '@rematch/core';
import { RootModel } from './index';

interface IState {
  isExpand: boolean;
}

const initialState: IState = {
  isExpand: true
};

export const drawer = createModel<RootModel>()({
  state: initialState as IState,
  reducers: {
    expandDrawer(state: IState): IState {
      return {
        ...state,
        isExpand: true
      };
    },
    collapseDrawer(state: IState): IState {
      return {
        ...state,
        isExpand: false
      };
    }
  }
});
